import { HttpService } from "../http";

export class JournalistService extends HttpService {
  async fetchJournalistRequests(payload: Record<string, any>): Promise<any> {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/journalist-approval-request`;

    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      console.error("Failed to fetch journalist requests:", error);
      throw error;
    }
  }

  async fetchDepartments(payload: Record<string, any> = {}): Promise<any> {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    // If subscriberId exists in payload, include it in URL, otherwise use base URL
    const baseUrl = `${baseAuthUrl}/api/departments/public`;

    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  }

  updateJournalistStatus = async (
    id: string | number,
    status: number
  ): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const url = `${baseAuthUrl}/api/journalist-approval-request/${id}/status`;
    try {
      console.log("Updating status to:", { status });
      const apiResponse = await this.patch(url, { status });
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteJournalist = async (id: string | number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const url = `${baseAuthUrl}/api/journalist-approval-request/${id}`;
    try {
      const apiResponse = await this.delete(url);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
  deleteJournalistManagement = async (id: string | number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const url = `${baseAuthUrl}/api/organization-membership/${id}`;
    try {
      const apiResponse = await this.delete(url);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  getSubscriberStats = async (slug: string) => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const url = `${baseAuthUrl}/api/organization-membership/subscriber-stats?slug=${encodeURIComponent(
      slug || ""
    )}`;

    try {
      const apiResponse = await this.get(url);
      return apiResponse;
    } catch (error) {
      console.error("Error fetching stats:", error);
      throw error;
    }
  };

  getTopCourses = async () => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const url = `${baseAuthUrl}/api/subscriber/top/courses`;
    try {
      const apiResponse = await this.get(url);
      return apiResponse;
    } catch (error) {
      console.error("Error fetching stats:", error);
      throw error;
    }
  };

  AllJournalist = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/organization-membership/journalist`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
